import React from 'react'

import { ReactComponent as Chevron } from '../../assets/icons/chevron.svg'
import { PageButton } from './PageButton/PageButton'

import './Pagination.scss'

const Dots = () => (
  <div className="dots">
    <span>...</span>
  </div>
)

export const Pagination = ({
  start,
  end,
  selected,
  onClick,
}) => {
  const bindClick = page => () => onClick(page)

  let btnsList = []
  if (end < 5) {
    for (let i = 1; i <= end; i++) {
      btnsList.push(
        <PageButton
          key={ i }
          label={ i }
          disabled={ selected === i }
          onClick={bindClick( i )}
        />
      )
    }
  } else if (selected <= 3) {
    btnsList = [
      <PageButton
        key={ start }
        label={ start }
        disabled={ selected === start }
        onClick={bindClick( start )}
      />,
      <PageButton
        key={ 2 }
        label="2"
        disabled={ selected === 2 }
        onClick={bindClick( 2 )}
      />,
      <PageButton
        key={ 3 }
        label="3"
        disabled={ selected === 3 }
        onClick={bindClick( 3 )}
      />,
      <Dots key="d" />,
      <PageButton
        key={ end }
        label={ end }
        disabled={ selected === end }
        onClick={bindClick( end )}
      />
    ]
  } else if (selected >= end - 2) {
    btnsList = [
      <PageButton
        key={ start }
        label={ start }
        disabled={ selected === start }
        onClick={bindClick( start )}
      />,
      <Dots key="d" />,
      <PageButton
        key={ end - 2 }
        label={ end - 2 }
        disabled={ selected === end - 2 }
        onClick={bindClick( end - 2 )}
      />,
      <PageButton
        key={ end - 1 }
        label={ end - 1 }
        disabled={ selected === end - 1 }
        onClick={bindClick( end - 1 )}
      />,
      <PageButton
        key={ end }
        label={ end }
        disabled={ selected === end }
        onClick={bindClick( end )}
      />
    ]
  } else {
    btnsList = [
      <PageButton
        key={ start }
        label={ start }
        disabled={ selected === start }
        onClick={bindClick( start )}
      />,
      <Dots key="d1" />,
      <PageButton
        key={ selected }
        label={ selected }
        disabled
      />,
      <Dots key="d2" />,
      <PageButton
        key={ end }
        label={ end }
        disabled={ selected === end }
        onClick={bindClick( end )}
      />
    ]
  }

  return (
    <div className="pagination-container">
      <button
        className="arrow-btn back"
        disabled={ selected === start }
        onClick={bindClick( selected - 1 )}
      >
        <Chevron />
      </button>
      { btnsList }
      <button
        className="arrow-btn next"
        disabled={ selected === end }
        onClick={bindClick( selected + 1 )}
      >
        <Chevron />
      </button>
    </div>
  )
}